import { AutocompleteInput, maxLength, ReferenceInput, required, SelectInput, TextInput } from "react-admin";
import { Grid, Typography } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { administrationRequests } from "api/administrationApi";

const GraduationInfo = ({ graduationInfo }) => {
  const isPrefilled = key => {
    const v = graduationInfo?.[key];
    return v !== undefined && v !== null && v !== "";
  };
  return (
    <>
      <Grid
        item
        xs={12}
      >
        <Typography
          color="primary"
          sx={{ mt: 2 }}
        >
          Информация за завършено висше образование
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="graduationInfo.university"
          label="Университет"
          validate={[required(), maxLength(200)]}
          readOnly={isPrefilled("university")}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="graduationInfo.higherEducationRecognitionCert"
          label="Сертификат за признаване на висше образование"
          validate={[maxLength(200)]}
          readOnly={isPrefilled("higherEducationRecognitionCert")}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="graduationInfo.qualificationRecognitionCert"
          label="Сертификат за признаване на квалификация"
          validate={[maxLength(200)]}
          readOnly={isPrefilled("qualificationRecognitionCert")}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="graduationInfo.graduationSpecialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
          filter={{ filterByUser: true }}
        >
          <AutocompleteInput
            label="Специалност"
            validate={[required()]}
            readOnly={isPrefilled("graduationSpecialityId")}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="graduationInfo.graduationDegreeId"
          reference={administrationRequests.getDegreesSelect()}
        >
          <SelectInput
            label="Квалификационна степен"
            validate={[required()]}
            readOnly={isPrefilled("graduationDegreeId")}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="graduationInfo.diplomaSeries"
          label="Серия на диплома"
          validate={[required(), maxLength(50)]}
          readOnly={isPrefilled("diplomaSeries")}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="graduationInfo.diplomaNumber"
          label="Номер на диплома"
          validate={[required(), maxLength(100)]}
          readOnly={isPrefilled("diplomaNumber")}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          source="graduationInfo.diplomaDate"
          label="Дата на издаване на диплома"
          validate={required()}
          readOnly={isPrefilled("diplomaDate")}
          noTime
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="graduationInfo.diplomaRegistrationNumber"
          label="Регистрационен номер на диплома"
          validate={[required(), maxLength(100)]}
          readOnly={isPrefilled("diplomaRegistrationNumber")}
        />
      </Grid>
    </>
  );
};

export default GraduationInfo;
